import React from "react";
import DataTable from "../../components/data-table";
import ValidationReg from "../../common/ValidationReg";
import * as Validations from "../../utils/validations";
import * as addressService from "../../services/kyc/address-service";
import * as kyc from "../../services/kyc/kyc-service";
import { v4 as uuidv4 } from "uuid";
import Auth from "../../utils/auth";
import {
  FUNCTIONALITY,
  ENTITLEMENTS,
  GSTIN_LinkValid,
  validFileExtensions,
  defaultListItem,
} from "../../common/const";
import { Authorize } from "../../components/authorize";
import * as xmlService from "../../services/xml/xml-service";
import { CSVLink } from "react-csv";
import { validateEntitlement } from "../../common/validate-entitlement";
import { downloadFile } from "../../common/download-file";
import * as Loader from "../../common/common";
import Utility from "../../components/modal";
import { messages } from "../../common/messages";
import TextBox from "../../components/form-controls/textbox";
import { dateFormat, StringToDate } from "../../utils/date";
import DatePicker from "react-datepicker";
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import * as validate from "../../utils/validations";
import DropDownGroup from "../../components/form-controls/dropdowngroup";
import DropDown from "../../components/form-controls/dropdown";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import XmlDownload from "../../components/xml-download/xml-download";
import * as validateFileExt from "../../common/validate-file-extension";
import config from "../../common/config";
import { withOutletPropsAndNavigation } from "../../common/hocs";

// const config = require("../../common/config");
let EditOrAdd = "",
  buttonName = "";
let formData = new FormData();
let dateFieldsStatus = false;

class Addresses extends Authorize {
  constructor(props) {
    super(props);
    this.addClick = this.addClick.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.FileUpload = this.FileUpload.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.getAddreses = this.getAddreses.bind(this);
    this.setServiceReponse = this.setServiceReponse.bind(this);
    this.onClear = this.onClear.bind(this);
    this.generateAddressXml = this.generateAddressXml.bind(this);
    this.getAddressesForCSV = this.getAddressesForCSV.bind(this);
    this.onContactNameKeyPress = this.onContactNameKeyPress.bind(this);
    this.onBankNameKeyPress = this.onBankNameKeyPress.bind(this);
    this.onClickLi = this.onClickLi.bind(this);
    this.onClickBankLi = this.onClickBankLi.bind(this);
    this.handlePrevNext = this.handlePrevNext.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onKeyPressDate = this.onKeyPressDate.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.downloadPdfList = this.downloadPdfList.bind(this);
    this.state = {
      clientId: props.clientId || Auth.get("userId"),
      userType: props.clientType,
      isAddress: props.tag === "BE" ? false : true,
      addressDefault: {
        addressId: "",
        addressCode: "",
        businessEntity: "",
        addressType: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        addressLine5: "",
        city: "",
        state: "",
        postalCode: "",
        gstin: "",
        gstinStatus: "",
        gstTaxpayerType: "",
        fromDate: "",
        toDate: "",
        emailIds: "",
        isActive: 1,
        isDeleted: 0,
        createdBy: "",
        updatedBy: "",
        clientId: "",
        files: "",
        contactName: "",
        contacts: [],
        contactId: "",
        bankId: "",
        bankName: "",
        banks: [],
        fileUploadType: "",
        bankDet: "",
      },
      address: {
        addressId: "",
        addressCode: "",
        businessEntity: "",
        addressType: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        addressLine5: "",
        city: "",
        state: "",
        postalCode: "",
        gstin: "",
        gstinStatus: "",
        gstTaxpayerType: "",
        fromDate: "",
        toDate: "",
        emailIds: "",
        isActive: 1,
        isDeleted: 0,
        createdBy: "",
        updatedBy: "",
        clientId: "",
        files: "",
        contactName: "",
        contacts: [],
        contactId: "",
        bankId: "",
        bankName: "",
        banks: [],
        fileUploadType: "",
        bankDet: "",
      },
      validationErrors: {},
      msg: "",
      err: "",
      fileUploadMsg: "",
      fileUploadErr: "",
      deleteMsg: "",
      stateData: "",
      gstStatusData: "",
      taxPayerTypesData: "",
      addressTypeData: "",
      showModel: false,
      message: "",
      pan: "",
      isSupplier: false,
      headers: [
        {
          title: "Type",
          accessor: "addressType",
          index: 1,
          dataType: "string",
        },
        {
          title: "Address Line 1",
          accessor: "addressLine1",
          index: 3,
          dataType: "string",
        },
        {
          title: "Address Line 2",
          accessor: "addressLine2",
          index: 4,
          dataType: "string",
        },
        {
          title: "",
          accessor: "",
          index: 5,
          cell: (row) => {
            return (
              <div key={row.contactId} className="btn-group  float-right">
                {validateEntitlement(
                  FUNCTIONALITY.addresses,
                  ENTITLEMENTS.edit
                ) ? (
                  <button
                    title="Edit"
                    type="button"
                    onClick={this.edit.bind(this, row.addressId)}
                    className="btn btn-sm btn-primary fas fa-edit rounded-0"
                  ></button>
                ) : null}
                {validateEntitlement(
                  FUNCTIONALITY.addresses,
                  ENTITLEMENTS.delete
                ) ? (
                  <button
                    title="Delete"
                    onClick={this.delete.bind(this, row.addressId)}
                    type="button"
                    className="btn btn-sm btn-danger fas fa-trash-alt rounded-0"
                  ></button>
                ) : null}
                <button
                  title="Download as PDF"
                  onClick={this.downloadPdf.bind(
                    this,
                    this.state.clientId,
                    row.addressId,
                    this.state.isAddress ? "Address" : "BusinessEntity"
                  )}
                  type="button"
                  className="btn btn-sm btn-warning  rounded-0"
                >
                  <span className="fa fa-download"></span>
                </button>
              </div>
            );
          },
        },
      ],
      data: [],
      isDisabled: false,
      validations: [
        {
          key: "addressType",
          label: "Address Type",
          props: { isRequired: true, format: "text" },
          format: "text",
        },
        {
          key: "businessEntity",
          label: "Business Entity",
          props: { format: "text" },
          format: "text",
          isAddress: "false",
        },
        {
          key: "addressLine1",
          label: "Address Line 1",
          props: { isRequired: true },
          format: "text",
        },
        {
          key: "city",
          label: "City",
          props: { isRequired: true, format: "text" },
          format: "text",
        },
        {
          key: "state",
          label: "State",
          props: { isRequired: true },
          format: "text",
        },
        {
          key: "gstin",
          label: "GSTIN No",
          props: { format: "GSTIN" },
          format: "GSTIN",
        },
        {
          key: "fromDate",
          label: "From Date",
          props: { format: "date" },
          format: "date",
        },
        {
          key: "toDate",
          label: "To Date",
          props: { format: "date" },
          format: "date",
        },
        {
          key: "postalCode",
          label: "Postal Code",
          props: { isRequired: true, format: "number" },
          format: "number",
        },
        {
          key: "emailIds",
          label: "Email",
          props: { format: "email" },
          format: "email",
        },
        {
          key: "gstinStatus",
          label: "GSTIN Status",
          props: { format: "text" },
          format: "text",
          isAddress: "true",
        },
        {
          key: "gstTaxpayerType",
          label: "Tax Payer Type",
          props: { format: "text" },
          format: "text",
          isAddress: "true",
        },
        {
          key: "files",
          label: "File",
          props: { format: "file" },
          format: "file",
          isAddress: "true",
        },
        {
          key: "contactName",
          label: "Contact Name",
          props: { format: "text" },
          format: "text",
          isAddress: "true",
        },
        {
          key: "bankDet",
          label: "Bank Details",
          props: { format: "text" },
          format: "text",
          isAddress: "true",
        },
        {
          key: "fileUploadType",
          label: "File Upload Type",
          props: { format: "text" },
          format: "text",
          isAddress: "true",
        },
      ],
      files: [],
      allFiles: [],

      fileUploadTypesData: [
        { code: "4", name: "SEZ Certificate" },
        { code: "5", name: "GST undertaking for non-registration" },
        { code: "6", name: "GSTIN Registration Certificate" },
        { code: "7", name: "GST terms of engagement for registered vendors" },
      ],
      csvData: [],
      csvHeaders: [],
      regenerateMsg: "",
    };
    this.Tag = this.props.tag;
  }

  kycStatus = "";

  async downloadPdf(clientId, addressId, addressType) {
    let data = {
      clientId: clientId,
      addressId: addressId,
      addressType: addressType,
    };
    let { response, err } = await commonDownloadPdfService.downloadAddress(
      data
    );
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(
        response.data,
        addressType + "_" + clientId + "_" + addressId
      );
    }
  }

  async downloadPdfList(clientId, addressType) {
    let data = {
      clientId: clientId,
      addressType: addressType,
    };
    let { response, err } = await commonDownloadPdfService.downloadAddressList(
      data
    );
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, addressType + "List_" + clientId);
    }
  }

  async edit(id, e) {
    await this.getFiles();

    if (this.props.tag !== "BE") {
      EditOrAdd = "Edit Address";
    } else {
      EditOrAdd = "Edit Business Entity";
    }

    buttonName = "Update";

    let editData = this.state.data.filter((ele) => {
      return ele.addressId === id;
    });

    let editFileData = this.state.allFiles.filter((ele) => {
      return ele.fileTypeId === id;
    });

    if (editData[0].gstTaxpayerType !== "SEZ Unit") {
      dateFieldsStatus = false;
    } else {
      dateFieldsStatus = true;
    }
    editData[0].fromDate1 = editData[0].fromDate
      ? new Date(StringToDate(editData[0].fromDate))
      : "";
    editData[0].toDate1 = editData[0].toDate
      ? new Date(StringToDate(editData[0].toDate))
      : "";
    if (this.state.showModel === false) {
      this.setState({
        msg: "",
        err: "",
        address: editData[0],
        files: editFileData,
        showModel: !this.state.showModel,
      });
    } else {
      this.setState({
        msg: "",
        err: "",
        address: editData[0],
        files: editFileData,
      });
    }
  }

  async delete(id, e) {
    if (this.state.isDisabled) return false;
    var that = this;
    var config = {
      message: messages.confirmDeleteFile,
      onYesClick: async function () {
        let { response, err } = await addressService.deleteAddress(id);
        that.setServiceReponse(response, err, "err", "msg");
        that.setState({
          msg: response.data.deleteMsg,
        });
        if (!err) {
          that.getAddreses();
        }
      },
      onNoClick: null,
    };
    Utility.showConfirm(config);
  }

  deleteFile(id, name) {
    var that = this;
    var config = {
      message: messages.confirmDeleteFile,
      onYesClick: async function () {
        let filesAfterDelete = [];

        if (that.state.files.length > 0) {
          filesAfterDelete = that.state.files.filter((ele) => {
            return ele.fileId !== id;
          });
        }
        let objDelFile = {
          fileId: id,
          name: name,
          userId: that.state.clientId,
        };
        let res = await addressService.deleteFileByFileId(objDelFile);
        if (!res.err) {
          that.setState({
            files: filesAfterDelete,
          });
        } else {
        }
      },
      onNoClick: null,
    };
    Utility.showConfirm(config);
  }

  async FileUpload(e) {
    let fileNames = [];
    let fileCount = e.target.files.length;
    let invalidFiles = [];
    let validationErrors = Object.assign({}, this.state.validationErrors);

    validationErrors["filesError"] = "";
    validationErrors["filesNotSupportedErrors"] = "";

    this.setState({
      validationErrors: validationErrors,
    });
    if (fileCount > 0) {
      for (let i = 0; i < e.target.files.length; i++) {
        let filesObj = {};
        Object.assign(filesObj, e.target.files);
        var filereader = new FileReader();
        const blob = filesObj[i].slice(0, 4);
        filereader.readAsArrayBuffer(blob);
        filereader.onloadend = async (evt) => {
          let isValidFileExtension = validateFileExt.validateFileExtensionMimeType(
            evt
          );
          if (isValidFileExtension) {
            let fileId = uuidv4();
            fileNames = [
              {
                fileId: fileId,
                fileName: filesObj[i].name,
                fileType: this.state.address.fileUploadType,
                fileTypeId: "",
              },
            ];

            formData = new FormData();
            var file = filesObj[i];
            formData.append("file", file);
            formData.append("filename", fileId + "_" + file.name);
            formData.append("userId", this.state.clientId);
            formData.append("fileType", this.state.address.fileUploadType);

            let { response1, err } = await addressService.uploadFile(formData);

            if (err) {
              this.setState({
                fileUploadErr:
                  "File limit has exceeded, Please upload file size of maximum 2 MB",
              });
            } else {
              this.setState({
                fileUploadErr: "",
                files: [...this.state.files, ...fileNames],
              });
            }

            document.getElementById("addressDocs").value = "";
          } else {
            invalidFiles.push(filesObj[i].name);
            validationErrors["filesError"] = messages.fileExtensionError;
            validationErrors["filesNotSupportedErrors"] = invalidFiles;

            this.setState({
              validationErrors: validationErrors,
            });
          }
        };
      }
    }
  }

  addClick() {
    if (this.props.tag !== "BE") {
      EditOrAdd = "New Address";
    } else {
      EditOrAdd = "New Business Entity";
    }
    buttonName = "Save";

    this.setState({
      address: Object.assign({}, this.state.addressDefault),
      showModel: !this.state.showModel,
      msg: "",
      err: "",
      deleteMsg: "",
      files: [],
      validationErrors: {},
      fileUploadMsg: "",
      fileUploadErr: "",
    });
  }

  onInputChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    let validationErrors = Object.assign({}, this.state.validationErrors);

    let rule = this.state.validations.find((v) => v.key === name);

    if (rule) {
      if (rule.format === "text") {
        if (value) {
          if (!ValidationReg.namehypenValid.test(value)) {
            validationErrors[name + "Error"] =
              messages.validErrorMessage + " " + rule.label;
          } else {
            validationErrors[name + "Error"] = "";
          }
        } else if (rule.props.isRequired) {
          if (Validations.isNullUndefinedEmpty(value)) {
            validationErrors[name + "Error"] =
              messages.requiredErrorMessage + " " + rule.label;
            if (this.state.isAddress && this.state.isSupplier) {
              document.getElementById("contactList").style.display = "none";
              document.getElementById("bankList").style.display = "none";
            }
          } else {
            validationErrors[name + "Error"] = "";
          }
        }
      } else if (rule.format === "number") {
        if (value) {
          if (!ValidationReg.numbersonlyValid.test(value)) {
            validationErrors[name + "Error"] =
              messages.validErrorMessage + " " + rule.label;
          } else {
            validationErrors[name + "Error"] = "";
          }
        } else if (rule.props.isRequired) {
          validationErrors[name + "Error"] = Validations.errorRequired(
            value,
            rule.label
          );
        }
      } else if (rule.format === "email") {
        if (value) {
          if (!ValidationReg.emailValid.test(value)) {
            validationErrors[name + "Error"] =
              messages.validErrorMessage + " " + rule.label;
          } else {
            validationErrors[name + "Error"] = "";
          }
        } else if (rule.props.isRequired) {
          validationErrors[name + "Error"] = Validations.errorRequired(
            value,
            rule.label
          );
        }
      } else if (rule.format === "GSTIN") {
        if (value) {
          if (!ValidationReg.GST_REG_EXP.test(value)) {
            validationErrors[name + "Error"] =
              messages.validErrorMessage + " " + rule.label;
          } else {
            validationErrors[name + "Error"] = "";
          }
        } else if (rule.props.isRequired) {
          validationErrors[name + "Error"] = Validations.errorRequired(
            value,
            rule.label
          );
        }
      } else {
        validationErrors[name + "Error"] = "";
      }
    }
    if (name === "gstinStatus" && value === "Un-Register") {
      validationErrors.gstinError = "";
      if (
        this.state.address.gstTaxpayerType === "Not Applicable" ||
        this.state.address.gstTaxpayerType === "Agro Products"
      ) {
        validationErrors["gstTaxpayerTypeError"] = "";
      }
    } else if (name === "gstinStatus" && value === "Register") {
      if (
        this.state.address.gstTaxpayerType !== "Not Applicable" &&
        this.state.address.gstTaxpayerType !== "Agro Products"
      ) {
        validationErrors["gstTaxpayerTypeError"] = "";
      }
    } else if (name === "gstTaxpayerType" && value !== "SEZ Unit") {
      dateFieldsStatus = false;

      if (
        name === "gstTaxpayerType" &&
        this.state.address.gstinStatus === "Register" &&
        (value === "Not Applicable" || value === "Agro Products")
      ) {
        validationErrors[name + "Error"] = "Select Different Tax Payer Type!";
      } else if (
        name === "gstTaxpayerType" &&
        this.state.address.gstinStatus === "Un-Register" &&
        value !== "Not Applicable" &&
        value !== "Agro Products"
      ) {
        validationErrors[name + "Error"] = "Select Different Tax Payer Type!";
      } else {
        validationErrors[name + "Error"] = "";
      }
    } else if (name === "gstTaxpayerType" && value === "SEZ Unit") {
      dateFieldsStatus = true;
      if (
        name === "gstTaxpayerType" &&
        this.state.address.gstinStatus === "Un-Register"
      ) {
        validationErrors[name + "Error"] = "Select Different Tax Payer Type!";
      } else {
        validationErrors[name + "Error"] = "";
      }
    } else if (this.state.isSupplier && name === "contactName" && value !== "") {
      validationErrors[name + "Error"] = "";

      this.onContactNameKeyPress(value);
    } else if (this.state.isSupplier && name === "bankDet" && value !== "") {
      validationErrors[name + "Error"] = "";
      this.onBankNameKeyPress(value);
    }

    if (
      name === "businessEntity" ||
      name === "addressLine1" ||
      name === "addressLine2" ||
      name === "addressLine3" ||
      name === "addressLine4" ||
      name === "city"
    ) {
      if (value === "" || value.match(config.regex)) {
        this.setState({
          address: {
            ...this.state.address,
            [name]: value.toUpperCase(),
          },
          validationErrors: validationErrors,
        });
      }
    } else {
      this.setState({
        address: {
          ...this.state.address,
          [name]: value,
        },
        validationErrors: validationErrors,
      });
    }
  }

  onKeyPress(e) {
    if (
      e.which === 32 ||
      (e.which !== 8 && isNaN(String.fromCharCode(e.which)))
    ) {
      e.preventDefault();
    }
  }

  onKeyPressDateValidation = (e) => {
    if (validate.isValidKeyPressDate(e.which)) {
      e.preventDefault();
      return false;
    }
  };
  onKeyPressDate = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let errorName = name + "Error";
    if (value.length > 10) {
      e.preventDefault();
      return false;
    }
    this.setState({
      address: {
        ...this.state.address,
        [name]: value,
      },
      validationErrors: {
        ...this.state.validationErrors,
        [errorName]: "",
      },
    });
  };
  async getFiles() {
    let { response } = await addressService.getFiles(this.state.clientId);
    let fileNames = [];

    if (response && response.data && response.data.length > 0) {
      fileNames = response.data.map((ele) => {
        return {
          fileId: ele.fileId,
          fileName: ele.fileName,
          fileType: ele.fileType,
          fileTypeId: ele.fileTypeId,
        };
      });
    }
    this.setState({
      allFiles: fileNames,
    });
  }

  isValidFiles(validFileExtn, files) {
    let filesNotSupportedErrors = [];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        let fileUploaded = files[i].fileName.split(".");
        let fileExtn = fileUploaded[fileUploaded.length - 1].toUpperCase();
        let isValidFileExtn = validFileExtn.filter((extn) => extn === fileExtn);
        if (isValidFileExtn.length === 0) {
          filesNotSupportedErrors.push(fileUploaded);
        }
      }
    }
    return filesNotSupportedErrors;
  }

  async onSubmit(id, e) {
    Loader.showLoader();
    e.preventDefault();
    let validationErrors = Object.assign({}, this.state.validationErrors);

    let address = Object.assign({}, this.state.address);
    let isValidationPass = true;
    for (let p in address) {
      if (address.hasOwnProperty(p)) {
        let rule = this.state.validations.find((v) => v.key === p);
        let value = address[p];
        if (rule) {
          if (rule.format === "text") {
            if (value) {
              if (!ValidationReg.namehypenValid.test(value)) {
                validationErrors[p + "Error"] =
                  messages.validErrorMessage + " " + rule.label;
              } else {
                validationErrors[p + "Error"] = "";
              }
            } else if (rule.props.isRequired) {
              let err = Validations.errorRequired(value, rule.label);
              validationErrors[p + "Error"] = err;
              if (err) {
                isValidationPass = false;
              }
            }
          } else if (rule.format === "number") {
            if (value) {
              if (!ValidationReg.numberValid.test(value)) {
                validationErrors[p + "Error"] =
                  messages.validErrorMessage + " " + rule.label;
                isValidationPass = false;
              } else {
                validationErrors[p + "Error"] = "";
              }
            } else if (rule.props.isRequired) {
              let err = Validations.errorRequired(value, rule.label);
              validationErrors[p + "Error"] = err;
              if (err) {
                isValidationPass = false;
              }
            }
          } else if (rule.format === "email") {
            if (value) {
              if (!ValidationReg.emailValid.test(value)) {
                validationErrors[p + "Error"] =
                  messages.validErrorMessage + " " + rule.label;
                isValidationPass = false;
              } else {
                validationErrors[p + "Error"] = "";
              }
            } else if (rule.props.isRequired) {
              validationErrors[p + "Error"] = Validations.errorRequired(
                value,
                rule.label
              );
              isValidationPass = false;
            }
          } else if (rule.format === "GSTIN") {
            let pan = this.state.pan;
            if (value) {
              if (!ValidationReg.GST_REG_EXP.test(value)) {
                validationErrors[p + "Error"] =
                  messages.validErrorMessage + " " + rule.label;
                isValidationPass = false;
              } else if (value.slice(2, 12) !== pan) {
                validationErrors[p + "Error"] =
                  "Not valid GSTIN for the given PAN";
                isValidationPass = false;
              } else {
                validationErrors[p + "Error"] = "";
              }
            } else if (rule.props.isRequired) {
              let err = Validations.errorRequired(value, rule.label);
              validationErrors[p + "Error"] = err;
              if (err) {
                isValidationPass = false;
              }
            }
          }
        }
      }
    }

    if (this.state.isAddress) {
      let err = Validations.errorRequired(address.gstinStatus, "GSTIN Status");
      validationErrors["gstinStatusError"] = err;
      if (err) {
        isValidationPass = false;
      }
      if (address["gstinStatus"] === "Register") {
        let label = "GSTIN No.",
          key = "gstin";
        let err = Validations.errorRequired(address[key], label);

        if (err) {
          isValidationPass = false;
          validationErrors[key + "Error"] = err;
        }
      }

      err = Validations.errorRequired(
        address.gstTaxpayerType,
        "Tax Payer Type"
      );
      validationErrors["gstTaxpayerTypeError"] = err;
      if (err) {
        isValidationPass = false;
      }
      if (address["gstTaxpayerType"] === "SEZ Unit") {
        let label = "From Date",
          key = "fromDate";
        let err = Validations.errorRequired(address[key], label);
        let isValidDate = validate.isValidDateFormat(address[key]);
        validationErrors[key + "Error"] = err;
        if (err) {
          isValidationPass = false;
        } else if (!isValidDate) {
          err = "Please enter from date in dd-mm-yyyy format";
          validationErrors[key + "Error"] = err;
          isValidationPass = false;
        }
        label = "To Date";
        key = "toDate";
        err = Validations.errorRequired(address[key], label);
        isValidDate = validate.isValidDateFormat(address[key]);

        validationErrors[key + "Error"] = err;
        if (
          StringToDate(this.state.address.fromDate) >
          StringToDate(this.state.address.toDate)
        ) {
          err = "SEZ From Date must be Lesser Than SEZ To Date";
          validationErrors[key + "Error"] = err;
        }
        if (err) {
          isValidationPass = false;
        } else if (!isValidDate) {
          err = "Please enter to date in dd-mm-yyyy format";
          validationErrors[key + "Error"] = err;
          isValidationPass = false;
        }
      }
      if(this.state.isSupplier) {
        err = Validations.errorRequired(address.contactName, "Contact Name");
        validationErrors["contactNameError"] = err;
        if (err) {
          isValidationPass = false;
        }
        err = Validations.errorRequired(address.bankDet, "Bank Details");
        validationErrors["bankDetError"] = err;
        if (err) {
          isValidationPass = false;
        }
      }
      err =
        this.state.files && this.state.files.length > 0
          ? ""
          : "Please select a File Upload Type";
      validationErrors["fileUploadTypeError"] = err;
      if (err) {
        isValidationPass = false;
      }

      if (
        (address.gstinStatus && address.gstinStatus === "Register") ||
        (address.gstTaxpayerType &&
          address.gstTaxpayerType.toLowerCase() !== "Regular".toLowerCase())
      ) {
        if (
          address.gstinStatus &&
          address.gstinStatus === "Register" &&
          (address.gstTaxpayerType.toLowerCase() ===
            "Not Applicable".toLowerCase() ||
            address.gstTaxpayerType.toLowerCase() ===
            "Agro Products".toLowerCase())
        ) {
          validationErrors["gstTaxpayerTypeError"] =
            "Select Different Tax Payer Type!";
          isValidationPass = false;
        }

        if (this.state.files.length === 0) {
          validationErrors["filesError"] = messages.uploadFileMessage;
          isValidationPass = false;
        } else {
          validationErrors["filesError"] = "";
        }
      }
      if (
        address.gstinStatus &&
        address.gstinStatus !== "Register" &&
        address.gstTaxpayerType.toLowerCase() !==
        "Not Applicable".toLowerCase() &&
        address.gstTaxpayerType.toLowerCase() !== "Agro Products".toLowerCase()
      ) {
        validationErrors["gstTaxpayerTypeError"] =
          "Select Different Tax Payer Type!";
        isValidationPass = false;
      }

      let chkFileUploads = this.validateFileUploads();
      if (chkFileUploads.length > 0) {
        validationErrors["requiredFileTypeError"] = chkFileUploads;
        isValidationPass = false;
      } else {
        validationErrors["requiredFileTypeError"] = "";
      }
    } else {
      let err = Validations.errorRequired(
        address.businessEntity,
        "Business Entity"
      );
      validationErrors["businessEntityError"] = err;
      if (err) {
        isValidationPass = false;
      }
    }

    if (isValidationPass) {
      let filesCount = this.state.files.length;
      let address = Object.assign({}, this.state.address);
      if (!id) {
        address.addressId = uuidv4();
      } else {
        address.addressId = id;
      }
      address.clientId = this.state.clientId;
      if (filesCount > 0) {
        let tmpfiles = this.state.files;
        let objFileUpload = [];
        for (var i = 0; i < tmpfiles.length; i++) {
          objFileUpload.push({
            fileId: tmpfiles[i].fileId,
            fileName: tmpfiles[i].fileName,
            fileType: `Address_${tmpfiles[i].fileType}`,
            clientId: this.state.clientId,
            fileTypeId: address.addressId,
            isActive: 1,
            isDeleted: 0,
            createdBy: Auth.get("userId"),
            updatedBy: "",
          });
        }
        await addressService.saveFileUpload(objFileUpload);
      }

      let { response, err } = await addressService.saveAddress(address);
      if (err) {
        this.setState(
          {
            msg: "Error: " + err,
          },
          Loader.hideLoader
        );
      } else if (response && response.data.err) {
        this.setState(
          {
            err: response.data.err,
          },
          Loader.hideLoader
        );
      } else {
        this.setState(
          {
            msg: response.data.msg,
            address: Object.assign({}, this.state.addressDefault),
            files: [],
            err: "",
            fileUploadErr: "",
            showModel: !this.state.showModel,
          },
          Loader.hideLoader
        );
      }
      if (filesCount > 0) {
        let { response1, err1 } = await addressService.uploadFile(formData);
        if (err1) {
          this.setState(
            {
              fileUploadMsg: "Error: " + err,
              fileUploadErr: "",
            },
            Loader.hideLoader
          );
        } else if (response1 && response1.data && response1.data.err) {
          this.setState(
            {
              fileUploadErr: response1.data.err,
              fileUploadMsg: "",
            },
            Loader.hideLoader
          );
        } else {
          this.setState(
            {
              fileUploadMsg: response1.data.msg,
              fileUploadErr: "",
              files: [],
            },
            Loader.hideLoader
          );
        }
      }
      this.getAddreses();
    } else {
      Loader.hideLoader();
      this.setState({
        validationErrors: validationErrors,
      });
    }
    Loader.hideLoader();
  }

  validateFileUploads = () => {
    let fileTypes = this.state.fileUploadTypesData;
    let fileUploadTypeError = [];
    for (let i = 0; i < fileTypes.length; i++) {
      let file = this.state.files.filter((ele) => {
        return ele.fileType === fileTypes[i].name;
      });

      if (file.length === 0) {
        if (
          fileTypes[i].name === "GST undertaking for non-registration" &&
          this.state.address.gstinStatus === "Un-Register" &&
          (this.state.address.gstTaxpayerType === "Not Applicable" ||
            this.state.address.gstTaxpayerType === "Agro Products")
        ) {
          fileUploadTypeError.push(fileTypes[i].name);
        } else if (
          fileTypes[i].name === "GSTIN Registration Certificate" &&
          this.state.address.gstinStatus === "Register" &&
          this.state.address.gstTaxpayerType !== "Not Applicable" &&
          this.state.address.gstTaxpayerType !== "Agro Products"
        ) {
          fileUploadTypeError.push(fileTypes[i].name);
        } else if (
          fileTypes[i].name ===
          "GST terms of engagement for registered vendors" &&
          this.state.address.gstinStatus === "Register" &&
          (this.state.address.gstTaxpayerType !== "Not Applicable" ||
            this.state.address.gstTaxpayerType !== "Agro Products") &&
          this.state.userType.toLowerCase() === "supplier"
        ) {
          fileUploadTypeError.push(fileTypes[i].name);
        } else if (
          fileTypes[i].name === "SEZ Certificate" &&
          this.state.address.gstTaxpayerType === "SEZ Unit"
        ) {
          fileUploadTypeError.push(fileTypes[i].name);
        }
      }
    }
    return fileUploadTypeError;
  };

  setServiceReponse(response, err, errField, dataField) {
    if (err) {
      this.setState({
        [errField]: err,
      });
    } else if (response.data && response.data.err) {
      this.setState({
        [errField]: response.data.err,
      });
    } else if (response.data && response.data.msg) {
      this.setState({
        [dataField]: response.data.msg,
      });
    } else if (dataField) {
      this.setState({
        [dataField]: response.data.data || [],
        pan: response.data.pan,
      });
    }
  }

  async getAddreses() {
    let { response, err } = await addressService.getAllActiveAddress(
      this.state.clientId,
      this.props.tag
    );
    await this.setServiceReponse(response, err, "err", "data");

    this.getFiles();
  }

  async setInitialData(context) {
    let gstStatusData = [];
    let stateData = [];
    let taxPayerTypesData = [];
    let addressTypeData = [];
    if (!!context) {
      let actions = context.actions;
      gstStatusData = actions.getMastersByGroup("GstStatus");
      stateData = actions.getMastersByGroup("State");
      taxPayerTypesData = actions.getMastersByGroup("TaxPayerType");
      addressTypeData = actions.getMastersByGroup("AddressType");
    }
    this.setState({
      ...this.state,
      gstStatusData: gstStatusData,
      stateData: stateData,
      taxPayerTypesData: taxPayerTypesData,
      addressTypeData: addressTypeData,
      deleteMsg: "",
      files: [],
    });
    await this.getAddreses();
  }

  // componentWillReceiveProps(nextProps) {
  //   this.setInitialData(nextProps.context);
  //   this.Tag = nextProps.tag;
  // }

  componentDidUpdate(prevProps) {
    if (this.props.context !== prevProps.context || this.props.tag !== prevProps.tag) {
      this.setInitialData(this.props.context);
      this.Tag = this.props.tag;
    }
  }

  async componentDidMount() {
    this.setInitialData(this.props && this.props.context);
    this.setState({
      isSupplier: this.props.clientType !== "Customer" ? true : false,
    });
    let clientId;
    if (Auth.get("userType") !== "InternalUser") {
      clientId = Auth.get("userId");
    } else {
      clientId = this.props.clientId;
    }
    Loader.showLoader();
    let { response, err } = await kyc.getKycStatus(clientId);
    Loader.hideLoader();
    if (err) {
    } else {
      this.kycStatus = response.data.kycStatus;
      if (Auth.get("userType") !== "InternalUser") {
        if (
          !this.kycStatus ||
          this.kycStatus === "REOPENED" ||
          this.kycStatus === "DRAFT" ||
          this.kycStatus === "REJECTED"
        ) {
          this.setState({
            isDisabled: false,
          });
        } else {
          this.setState({
            isDisabled: true,
          });
        }
      }
    }
    if (
      validateEntitlement(FUNCTIONALITY.generateXMLCSV, ENTITLEMENTS.create) &&
      this.kycStatus === "APPROVED"
    ) {
      this.getAddressesForCSV();
    }
  }

  onClear() {
    this.setState({
      ...this.state,
      address: Object.assign({}, this.state.addressDefault),
      validationErrors: {},
      msg: "",
      err: "",
      deleteMsg: "",
      fileUploadErr: "",
      fileUploadMsg: "",
    });
  }

  async generateAddressXml() {
    Loader.showLoader();
    let data = {
      clientId: this.state.clientId,
      userType: this.state.userType,
    };
    let { response, err } = await xmlService.generateAddressXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  async getAddressesForCSV() {
    Loader.showLoader();
    let { response, err } = await addressService.getAddressesForCSV(
      this.state.clientId
    );
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else if (response.data && response.data.length > 0) {
      let data = response.data;
      let headers = [];
      for (let i = 0; i < 1; i++) {
        for (let key in data[i]) {
          headers.push(key);
        }
      }
      this.setState({
        csvData: data,
        csvHeaders: headers,
      });
    }
  }

  async downloadFile(name, id) {
    downloadFile(this, name, id);
  }

  getFileName() {
    let fileType = ".csv";
    let date = new Date(),
      dateformat = [
        date.getDate(),
        date.getMonth() + 1,
        date.getFullYear(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ].join("-");
    let fileName;
    fileName = "Addresses_" + this.state.clientId + "_" + dateformat + fileType;
    return fileName;
  }

  async onContactNameKeyPress(value) {
    if (value !== "") {
      document.getElementById("contactId").classList.remove("hide");
      let { response, err } = await addressService.getContacts(
        value,
        this.state.clientId
      );
      document.getElementById("contactId").classList.add("hide");
      if (err) {
      } else if (response && response.err) {
      } else {
        document.getElementById("contactList").style.display = "";
        let contacts = response.data.data;

        this.setState({
          address: {
            ...this.state.address,
            contacts: contacts,
            loading: false,
          },
        });
      }
    }
  }

  onClickLi(e) {
    let value = e.target.getAttribute("data-contact-person");
    let contactId = e.target.getAttribute("data-contactId");

    this.setState({
      address: {
        ...this.state.address,
        contactName: value,
        contactId: contactId,
      },
    });
    document.getElementById("contactList").style.display = "none";
  }

  onClickBankLi(e) {
    let value = e.target.getAttribute("data-bankid");
    let bankName = e.target.innerText;
    this.setState({
      address: {
        ...this.state.address,
        bankName: "",
        bankId: value,
        bankDet: bankName,
      },
    });
    document.getElementById("bankList").style.display = "none";
  }

  async onBankNameKeyPress(value) {
    document.getElementById("bankId").classList.remove("hide");
    let { response, err } = await addressService.getBankDet(
      value,
      this.state.clientId
    );
    document.getElementById("bankId").classList.add("hide");
    if (err) {
    } else if (response && response.err) {
    } else {
      document.getElementById("bankList").style.display = "";
      let banks = response.data.data;
      this.setState({
        address: {
          ...this.state.address,
          banks: banks,
        },
      });
    }
  }

  handlePrevNext(v, e) {
    if (v && v === "prev") {
      if (this.state.userType === "Customer") {
        if (this.state.userType !== Auth.get("userType")) {
          this.props.navigate(
            "/kycs/" +
            this.state.clientId +
            "/" +
            this.state.userType +
            "/customer"
          );
        } else {
          this.props.navigate("/kyc/customer");
        }
      } else if (
        this.state.userType === "Supplier" ||
        this.state.userType === "CustomerSupplier"
      ) {
        if (this.props.tag === "BE") {
          if (this.state.userType !== Auth.get("userType")) {
            this.props.navigate(
              "/kycs/" +
              this.state.clientId +
              "/" +
              this.state.userType +
              "/addresses"
            );
          } else {
            this.props.navigate("/kyc/addresses");
          }
        } else if (this.props.tag !== "BE") {
          if (this.state.userType !== Auth.get("userType")) {
            this.props.navigate(
              "/kycs/" +
              this.state.clientId +
              "/" +
              this.state.userType +
              "/banks"
            );
          } else {
            this.props.navigate("/kyc/banks");
          }
        }
      }
    } else if (v && v === "next") {
      if (this.state.userType === "Customer") {
        if (this.state.userType !== Auth.get("userType")) {
          this.props.navigate(
            "/kycs/" +
            this.state.clientId +
            "/" +
            this.state.userType +
            "/taxids"
          );
        } else {
          this.props.navigate("/kyc/addresses");
        }
      } else if (
        this.state.userType === "Supplier" ||
        this.state.userType === "CustomerSupplier"
      ) {
        if (this.props.tag !== "BE") {
          if (this.state.userType !== Auth.get("userType")) {
            this.props.navigate(
              "/kycs/" +
              this.state.clientId +
              "/" +
              this.state.userType +
              "/businessentity"
            );
          } else {
            this.props.navigate("/kyc/businessentity");
          }
        } else if (this.props.tag === "BE") {
          if (this.state.userType !== Auth.get("userType")) {
            this.props.navigate(
              "/kycs/" +
              this.state.clientId +
              "/" +
              this.state.userType +
              "/taxids"
            );
          } else {
            this.props.navigate("/kyc/businessentity");
          }
        }
      }
    }
  }

  handleChange(name, date) {
    if (date !== undefined && date !== null && date !== "") {
      let formatedDate = dateFormat(date);
      this.setState({
        address: {
          ...this.state.address,
          [name + 1]: date,
          [name]: formatedDate,
        },
      });
    }
  }
  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }
    
    let disable = this.state.isDisabled;
    let noRecods = "No records found";
    let fileUploadTypeOptions = [];
    let forLength = this.state.fileUploadTypesData.length;
    if (this.state.userType.toLowerCase() === "customer") {
      forLength -= 1;
    }
    for (let index = 0; index < forLength; index++) {
      const element = this.state.fileUploadTypesData[index];
      fileUploadTypeOptions.push(
        <option key={index} value={element.name}>
          {element.name}
        </option>
      );
    }

    let headers;
    if (this.props.tag === "BE") {
      headers = [
        ...this.state.headers,
        {
          title: "Business Entity",
          accessor: "businessEntity",
          index: 2,
          dataType: "string",
        },
      ];
    } else {
      headers = this.state.headers;
    }
    let addresses = [];
    let addressCount = this.state.addressTypeData.length;
    for (let k = 0; k < addressCount; ++k) {
      let a = this.state.addressTypeData[k];
      if (a["name"].toLowerCase() !== "default") {
        addresses.push(a);
      }
    }
    let files = [];
    if (this.state.files != null) {
      if (this.state.files.length > 0) {
        files = this.state.files.map((element, index) => {
          if (element.fileType.indexOf("Address_") > -1) {
            element.fileType = element.fileType.split("_")[1];
          }
          return (
            <div key={index} className="row mt-2">
              {element.fileType ? (
                <div className="col-md-3 ">
                  <span className="">{element.fileType} </span>
                </div>
              ) : null}

              <div className="col-sm-6 ">
                <span className=""> {element.fileName}</span>
              </div>
              {!disable ? (
                <div className="col-sm-1 ">
                  <span alt="Delete" className="">
                    <a
                      title="Delete"
                      className="fa fa-trash text-danger"
                      onClick={this.deleteFile.bind(
                        this,
                        element.fileId,
                        element.fileName
                      )}
                    >
                      {" "}
                    </a>
                  </span>
                </div>
              ) : null}
              <div className="col-sm-1 ">
                <span alt="Download" className="">
                  <a
                    title="Download"
                    onClick={this.downloadFile.bind(
                      this,
                      element.fileName,
                      element.fileId
                    )}
                  >
                    <i className="fa fa-download"></i>
                  </a>
                </span>
              </div>
            </div>
          );
        });
      }
    }
    let userType = Auth.get("userType");
    let link = "";
    if (userType === GSTIN_LinkValid) {
      link = (
        <a
          href="https://services.gst.gov.in/services/searchtp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="icon-link"></i>
        </a>
      );
    } else {
      link = "";
    }
    let contacts = this.state.isSupplier ? this.state.address.contacts : null;
    let banks = this.state.isSupplier ? this.state.address.banks : null;
    let lis,
      bankLis = "";
    if (contacts) {
      if (contacts.length > 0) {
        lis = contacts.map((element, index) => {
          return (
            <li
              key={index}
              style={{ cursor: "pointer" }}
              className="list-group-item"
              data-contactId={element.contactId}
              data-contact-person={element.contactPerson}
              onClick={this.onClickLi}
            >
              {element.contactPerson} - {element.designation}
            </li>
          );
        });
      }
    }
    if (banks) {
      if (banks.length > 0) {
        bankLis = banks.map((element, index) => {
          return (
            <li
              key={index}
              style={{ cursor: "pointer" }}
              className="list-group-item"
              data-bankid={element.bankId}
              data-bankname={element.bankName}
              onClick={this.onClickBankLi}
            >
              {element.bankName} - {element.accountNumber}
            </li>
          );
        });
      }
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            {/* {this.state.deleteMsg && (
              <div className="alert alert-success">{this.state.deleteMsg}</div>
            )} */}
            {this.state.msg && (
              <div className="alert alert-success">{this.state.msg}</div>
            )}

            {this.state.err && (
              <div className="alert alert-error">{this.state.err}</div>
            )}

            {this.state.regenerateMsg && (
              <div className="alert alert-success">
                {this.state.regenerateMsg}
              </div>
            )}

            <span className="float-sm-right btn-group ">
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) &&
                this.kycStatus === "APPROVED" &&
                !this.state.showModel ? (
                <React.Fragment>
                  <button
                    className="btn btn-warning btn-xs "
                    onClick={this.generateAddressXml}
                  >
                    Generate XML
                  </button>
                  <XmlDownload
                    type="address/be"
                    obj={{
                      clientId:
                        Auth.get("userType") !== "InternalUser"
                          ? Auth.get("userId")
                          : this.props.clientId,
                      userType:
                        Auth.get("userType") !== "InternalUser"
                          ? Auth.get("userType")
                          : this.props.clientType,
                    }}
                  />
                </React.Fragment>
              ) : null}
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) &&
                this.kycStatus === "APPROVED" &&
                !this.state.showModel ? (
                this.state.csvHeaders &&
                  this.state.csvHeaders.length > 0 &&
                  this.state.csvData &&
                  this.state.csvData.length > 0 ? (
                  <button className="btn  btn-info btn-xs">
                    <CSVLink
                      style={{ color: "black" }}
                      headers={this.state.csvHeaders}
                      data={this.state.csvData}
                      filename={this.getFileName()}
                    >
                      <i className="fa fa-download text-black"></i> CSV
                    </CSVLink>
                  </button>
                ) : null
              ) : null}

              {!this.state.showModel ? (
                <button
                  className="btn  btn-info btn-xs"
                  title="Download PDF"
                  onClick={this.downloadPdfList.bind(
                    this,
                    this.state.clientId,
                    this.state.isAddress ? "Address" : "BusinessEntity"
                  )}
                >
                  <i className=" fa fa-download text-black"></i> PDF
                </button>
              ) : null}
            </span>
            <div className="row mt-1">
              <div className="col-sm-12 text-center">
                <p className="text-danger text-center font-weight-bold">
                  If you have any secondary address then please update here or
                  else you skip and proceed further.
                </p>
              </div>
            </div>

            <button
              disabled={disable && !this.state.showModel}
              className={
                this.state.showModel
                  ? "btn btn-sm btn-danger fixedCtaBtn"
                  : "btn btn-sm btn-success fixedCtaBtn"
              }
              onClick={this.addClick}
            >
              {this.state.showModel ? "CLOSE" : "ADD"}
            </button>
          </div>
          <div
            style={
              this.state.showModel ? { display: "none" } : { display: "block" }
            }
            className="col-sm-12"
          >
            <DataTable
              keyField="id"
              pagination={{
                enabled: true,
                pageLength: 15,
                type: "long",
              }}
              width="100%"
              title={this.state.isAddress ? "Addresses" : "Business Entity"}
              headers={headers}
              data={this.state.data}
              noData="No records!"
            />
            <div className="row mt-1">
              <div className="col-sm-12 text-center">
                <p className="text-danger text-center font-weight-bold">
                  If you have any secondary address then please update here or
                  else you skip and proceed further.
                </p>
              </div>
            </div>

            <div className="row pt-2">
              <div className="col-sm-12 text-center">
                <a
                  className="fa fa-angle-double-left mr-3 text-muted arrow"
                  onClick={this.handlePrevNext.bind(this, "prev")}
                >
                  {" "}
                </a>
                {(this.state.userType === "Supplier" && this.state.isAddress) ||
                  Auth.get("userType") === "InternalUser" ? (
                  <a
                    className="fa fa-angle-double-right text-black arrow"
                    onClick={this.handlePrevNext.bind(this, "next")}
                  >
                    {" "}
                  </a>
                ) : null}
              </div>
            </div>
          </div>
          {this.state.showModel ? (
            <div className="col-sm-12">
              {/* {/ <form> /} */}
              <form id="formClient">
                <h3 style={{ textAlign: "center" }}>{EditOrAdd}</h3>
                <div className=" row">
                  {this.props.tag === "BE" ? (
                    <div className="col-sm-4">
                      <TextBox
                        type="text"
                        animatedClass="fg-animate"
                        label="Business Entity"
                        required="true"
                        value={this.state.address.businessEntity}
                        name="businessEntity"
                        error={this.state.validationErrors.businessEntityError}
                        onChange={this.onInputChange}
                        disabled={disable}
                      />
                    </div>
                  ) : null}
                  <div className="col-sm-4">
                    <div className="form-group">
                      <DropDown
                        label="Address Type"
                        name="addressType"
                        required="true"
                        value={this.state.address.addressType || ""}
                        error={this.state.validationErrors.addressTypeError}
                        onChange={this.onInputChange}
                        defaultItem={defaultListItem}
                        list={addresses}
                        valProp="name"
                        textProp="name"
                        disabled={disable}
                      />
                      {/* <select className={this.state.validationErrors.addressTypeError ? 'is-invalid form-control' : 'form-control'} name='addressType' value={this.state.address.addressType || ""} onChange={this.onInputChange}  disabled={disable}>
                                                <option key="select" value="" >--Select--</option>
                                                {addressTypeOptions}
                                            </select> 
                                            <span className="error-msg">{this.state.validationErrors.addressTypeError}</span>*/}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="Address Line 1"
                      required="true"
                      value={this.state.address.addressLine1}
                      name="addressLine1"
                      error={this.state.validationErrors.addressLine1Error}
                      onChange={this.onInputChange}
                      maxLength="30"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="Address Line 2"
                      value={this.state.address.addressLine2}
                      name="addressLine2"
                      error={this.state.validationErrors.addressLine2Error}
                      onChange={this.onInputChange}
                      maxLength="30"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="Address Line 3"
                      value={this.state.address.addressLine3}
                      name="addressLine3"
                      error={this.state.validationErrors.addressLine3Error}
                      onChange={this.onInputChange}
                      maxLength="30"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="Address Line 4"
                      value={this.state.address.addressLine4}
                      name="addressLine4"
                      error={this.state.validationErrors.addressLine4Error}
                      onChange={this.onInputChange}
                      maxLength="30"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="City"
                      required="true"
                      value={this.state.address.city}
                      name="city"
                      error={this.state.validationErrors.cityError}
                      onChange={this.onInputChange}
                      maxLength="100"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <DropDown
                        label="State"
                        name="state"
                        required="true"
                        value={this.state.address.state || ""}
                        error={this.state.validationErrors.stateError}
                        onChange={this.onInputChange}
                        defaultItem={defaultListItem}
                        list={this.state.stateData}
                        valProp="code"
                        textProp="name"
                        disabled={disable}
                      />
                      {/* <label className="" htmlFor="state">State<span className="mandatory">*</span></label>
                                            <select className={this.state.validationErrors.stateError ? 'is-invalid form-control' : 'form-control'} name='state' value={this.state.address.state || ""} onChange={this.onInputChange} disabled={disable}>
                                                <option key="select" value="" >--Select--</option>
                                                {stateOptions}
                                            </select>
                                            <span className="error-msg">{this.state.validationErrors.stateError}</span> */}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="Postal Code"
                      required="true"
                      value={this.state.address.postalCode}
                      name="postalCode"
                      error={this.state.validationErrors.postalCodeError}
                      onChange={this.onInputChange}
                      maxLength="6"
                      disabled={disable}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextBox
                      type="text"
                      animatedClass="fg-animate"
                      label="Email"
                      value={this.state.address.emailIds}
                      name="emailIds"
                      error={this.state.validationErrors.emailIdsError}
                      onChange={this.onInputChange}
                      maxLength="100"
                      disabled={disable}
                    />
                  </div>

                  {/* <TextBox label="Address Line 5" value={this.state.address.addressLine5} name="addressLine5" error={this.state.validationErrors.addressLine5Error} onChange={this.onInputChange}/> */}

                  {this.state.isAddress ? (
                    <React.Fragment>
                      { this.state.isSupplier ? (
                        <>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="" htmlFor="state">
                            Contact Name<span className="mandatory">*</span>
                          </label>
                          <span id="contactId" className="loading hide"></span>
                          <input
                            type="text"
                            name="contactName"
                            autoComplete="off"
                            className={
                              this.state.validationErrors.contactNameError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            value={this.state.address.contactName || ""}
                            onChange={this.onInputChange}
                            disabled={disable}
                          />

                          <div id="contactList" style={{ display: "none" }}>
                            {this.state.address.contacts !== undefined ? (
                              <ul
                                style={{ overflowY: "auto" }}
                                className="list-group"
                                id="userList"
                              >
                                {this.state.address.contacts.length > 0 ? (
                                  lis
                                ) : (
                                  <li className="list-group-item active">
                                    {noRecods}
                                  </li>
                                )}
                              </ul>
                            ) : (
                              <div>&nbsp;</div>
                            )}
                          </div>
                          <span className="error-msg">
                            {this.state.validationErrors.contactNameError}
                          </span>
                          <p className="text-muted">
                            <small>Note : {config["contactNameNote"]} </small>{" "}
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="" htmlFor="state">
                            Bank Details<span className="mandatory">*</span>
                          </label>
                          <span id="bankId" className="loading hide"></span>
                          <input
                            type="text"
                            name="bankDet"
                            autoComplete="off"
                            className={
                              this.state.validationErrors.bankDetError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            value={this.state.address.bankDet || ""}
                            onChange={this.onInputChange}
                            disabled={disable}
                          />

                          <div id="bankList" style={{ display: "none" }}>
                            {this.state.address.banks !== undefined ? (
                              <ul
                                style={{ overflowY: "auto" }}
                                className="list-group"
                                id="userList"
                              >
                                {this.state.address.banks.length > 0 ? (
                                  bankLis
                                ) : (
                                  <li className="list-group-item active">
                                    {noRecods}
                                  </li>
                                )}
                              </ul>
                            ) : (
                              <div>&nbsp;</div>
                            )}
                          </div>
                          <span className="error-msg">
                            {this.state.validationErrors.bankDetError}
                          </span>
                          <p className="text-muted">
                            <small>Note : {config["bankDetNote"]}</small>{" "}
                          </p>
                        </div>
                      </div> 
                      </>
                      ) : null}
                      <div className="col-sm-4">
                        <div className="form-group">
                          <DropDownGroup
                            label="GSTIN Status"
                            name="gstinStatus"
                            required="true"
                            value={this.state.address.gstinStatus || ""}
                            error={this.state.validationErrors.gstinStatusError}
                            onChange={this.onInputChange}
                            defaultItem={defaultListItem}
                            list={this.state.gstStatusData}
                            valProp="name"
                            textProp="name"
                            disabled={disable}
                            customhref={
                              this.state.isSupplier &&
                                this.state.address.gstinStatus === "Register"
                                ? "/downloads/gst_terms_of_engagement_for_registered_vendors.docx"
                                : "/downloads/gst_undertaking_for_non_registration.docx"
                            }
                            customTitle="Sample GST Declaration form"
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="">GSTIN No {link}</label>
                          <input
                            type="text"
                            className={
                              this.state.validationErrors.gstinError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            placeholder="GSTIN No."
                            name="gstin"
                            maxLength="15"
                            value={this.state.address.gstin}
                            onChange={this.onInputChange}
                            autoComplete="off"
                            disabled={disable}
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.gstinError}
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <DropDown
                            label="Tax Payer Type"
                            name="gstTaxpayerType"
                            required="true"
                            value={this.state.address.gstTaxpayerType || ""}
                            error={
                              this.state.validationErrors.gstTaxpayerTypeError
                            }
                            onChange={this.onInputChange}
                            defaultItem={defaultListItem}
                            list={this.state.taxPayerTypesData}
                            valProp="name"
                            textProp="name"
                            disabled={disable}
                          />
                          {/* <label className="" htmlFor="pan">Tax Payer Type<span className="mandatory">*</span></label>
                                                        <select className={this.state.validationErrors.gstTaxpayerTypeError ? 'is-invalid form-control' : 'form-control'} name='gstTaxpayerType' value={this.state.address.gstTaxpayerType || ""} onChange={this.onInputChange} disabled={disable}>
                                                            <option key="select" value="" >--Select--</option>
                                                            {taxPayerOptions}
                                                        </select>
                                                        <span className="error-msg">{this.state.validationErrors.gstTaxpayerTypeError}</span> */}
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}
                  {this.state.isAddress && dateFieldsStatus ? (
                    <React.Fragment>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>
                            From Date<span className="mandatory">*</span>&nbsp;
                          </label>
                          <DatePicker
                            className={
                              this.state.validationErrors.fromDateError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            maxLength="10"
                            placeholderText="dd-mm-yyyy"
                            name="fromDate"
                            placeholder="dd-mm-yyyy"
                            selected={this.state.address.fromDate1 || ""}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onKeyDown={this.onKeyPressDateValidation}
                            onChange={this.handleChange.bind(this, "fromDate")}
                            onChangeRaw={this.onKeyPressDate}
                            autoComplete="off"
                            disabled={disable}
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.fromDateError}
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>
                            To Date<span className="mandatory">*</span>
                          </label>
                          <DatePicker
                            className={
                              this.state.validationErrors.toDateError
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            dateFormat="dd-MM-yyyy"
                            minDate={this.state.address.fromDate1}
                            maxLength="10"
                            placeholderText="dd-mm-yyyy"
                            name="toDate"
                            placeholder="dd-mm-yyyy"
                            selected={this.state.address.toDate1}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={this.handleChange.bind(this, "toDate")}
                            onKeyDown={this.onKeyPressDateValidation}
                            onChangeRaw={this.onKeyPressDate}
                            autoComplete="off"
                            disabled={disable}
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.toDateError}
                          </span>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}
                </div>

                {this.state.isAddress ? (
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        {/* <DropDown label='File Upload Type' name='fileUploadType' required='true' value={this.state.address.requiredFileTypeError || ""} error={this.state.validationErrors.requiredFileTypeError} onChange={this.onChange} defaultItem={defaultListItem} list={fileUploadTypeOptions} valProp="name" textProp="name" /> */}
                        <label htmlFor="fileUploadType">
                          File Upload Type &nbsp;{" "}
                          <span className="error-msg">
                            {this.state.validationErrors.fileUploadTypeError}
                          </span>
                        </label>

                        <select
                          name="fileUploadType"
                          className={
                            this.state.validationErrors.fileUploadTypeError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          value={this.state.address.fileUploadType || ""}
                          onChange={this.onInputChange}
                          disabled={disable}
                        >
                          <option key="select" value="">
                            --Select--
                          </option>
                          {fileUploadTypeOptions}
                        </select>

                        {this.state.validationErrors.requiredFileTypeError &&
                          this.state.validationErrors.requiredFileTypeError
                            .length > 0 &&
                          this.state.validationErrors.requiredFileTypeError.map(
                            (docType, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <span style={{ color: "#20A8D8" }}>
                                    *Upload file for {docType}{" "}
                                  </span>
                                  <br />
                                </React.Fragment>
                              );
                            }
                          )}
                      </div>
                      <div className="form-group">
                        <div>
                          <span style={{ color: "#73818f" }}>
                            <small>
                              Supported File Formats:{" "}
                              {validFileExtensions.join(",")}
                            </small>{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <label className="">File Upload</label>
                      {/* <div className="form-group">
                                                <span style={{ color: "#73818f" }}><small> Click the link to download template for GST declaration form
                                                <a href="/downloads/gst_undertaking_for_non_registration.docx" download={true}> &nbsp; <i className="nav-icon fa fa-download"></i></a>
                                                </small></span>
                                            </div> */}

                      <div>
                        <input
                          type="file"
                          id="addressDocs"
                          name="file"
                          multiple
                          size="50"
                          style={{ color: "transparent" }}
                          onChange={this.FileUpload}
                          autoComplete="off"
                          disabled={disable}
                        />
                        <div className="col-md-12">{files}</div>
                        <span className="error-msg">
                          {this.state.validationErrors.filesError}
                        </span>
                        {this.state.fileUploadErr ? (
                          <div className="alert alert-danger">
                            {this.state.fileUploadErr}
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.validationErrors.filesNotSupportedErrors &&
                          this.state.validationErrors.filesNotSupportedErrors
                            .length > 0 &&
                          this.state.validationErrors.filesNotSupportedErrors.map(
                            (docType, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <span className="error-msg">
                                    File format not supported for {docType}
                                  </span>
                                  <br />
                                </React.Fragment>
                              );
                            }
                          )}
                        <div>
                          <span style={{ color: "#008000" }}>
                            {this.state.fileUploadMsg}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="row mb-2">
                  <div className="col-sm-12">
                    <button
                      className="btn btn-primary rounded-0"
                      disabled={disable}
                      onClick={this.onSubmit.bind(
                        this,
                        this.state.address.addressId
                      )}
                    >
                      {buttonName}
                    </button>
                    <span>&nbsp;</span>
                    <button
                      className="btn btn-default rounded-0"
                      type="button"
                      onClick={this.onClear}
                      disabled={disable}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </form>

              {/* {/ </form > /} */}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

// HOC to inject outlet context props and navigation function
export default withOutletPropsAndNavigation(Addresses);